<template>
  <div class="social-comment list-complete-item">
    <div class="comment-header" v-if="comment.owner != null">
      <i class="social-comment-icon"></i>
      <img :src="$imageus + (comment.owner.image == null ? host + '/static/500x500-user.png' : comment.owner.image) + '?width=200&height=200&mode=cover'" @click="openUserModal(comment)" alt="" />
      <div class="comment-user-title" @click="openUserModal(comment)">
        <span class="comment-user-title-text">{{ comment.owner.fullName }}</span>
        <span class="time">{{ moment(comment.createDate).fromNow() }}</span>
      </div>
      <div class="comment-owner">
        <el-dropdown v-if="comment.owner != null && comment.owner.id == currentUser.id">
          <span class="el-dropdown-link"><i class="fas fa-ellipsis-v"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="fas fa-trash" @click.native="deleteComment(comment.id)">{{ $t("socialhub.deleteComment") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="comment-body">
      <div class="comment-text">
        <span v-html="parseUrl(comment.commentText, comment)"> </span>
      </div>
      <div class="comment-buttons">
        <!-- <span>{{moment(comment.createDate).fromNow()}}</span> -->
        <span @click="openSubComment" v-show="comment.subCommentCount > 0">{{ comment.subCommentCount }} {{ $t("socialhub.bigComment") }}</span>
        <span
          class="comment-reply"
          :style="{ color: newComment ? '#FF6565' : '#292F3B' }"
          @click="
            newComment = !newComment;
            commentForm.commentText = null;
          "
          >{{ newComment ? $t("socialhub.cancel") : $t("socialhub.reply") }}</span
        >
        <!-- <div class="like-area">
          <span>{{ comment.likeCount }} Beğeni</span>
          <i class="hearth-icon" :class="{ active: comment.isLiked }" @click="toggleLikeComment"></i>
        </div> -->
        <div class="like-area" @click="toggleLikeComment">
          <span v-if="comment.likeCount > 0">{{ comment.likeCount }}</span>
          <i class="el-icon-loading" v-if="loading == 'commentLike'"></i>
          <i :class="comment.isLiked ? 'fa fa-heart active' : 'far fa-heart'" v-else></i>
        </div>
      </div>
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="send-comment" v-if="newComment" :key="'new-comment-area-' + comment.id + '-key-' + newComment" @keyup.enter.exact="postComment()">
          <div v-if="isCommentMentionVisible" v-dragscroll.x class="mention-panel">
            <div v-for="(user, index) in users" :key="index" @click="tagUser(user, commentForm)" class="mention-item">
              <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
              <p v-if="user.type == 2">{{ user.title }}</p>
              <p else>{{ user.fullName }}</p>
            </div>
          </div>
          <el-input v-model="commentForm.commentText" resize="auto" class="comment-input" @input="commentMention(commentForm)">
            <template slot="suffix">
              <i class="el-input__icon fas " :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment()"></i>
            </template>
          </el-input>
        </div>
      </transition>
      <div class="comment-sub-comments" v-if="subCommentOpen">
        <transition-group name="list-complete" tag="div">
          <SubComment v-for="subComment in comment.subComments" :key="subComment.id + '-sub-comment'" :subComment="subComment" />
        </transition-group>
        <div class="load-comment-btn" v-if="loadCommentBtn">
          <el-button type="primary" round size="mini" :loading="loading == 'loadComments'" @click="loadComment">{{ $t("socialhub.loadMore") }}</el-button>
        </div>
        <div class="load-comment-btn" v-else>
          <el-button size="mini" type="success" round @click="subCommentOpen = false">{{ $t("socialhub.hideReply") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubComment from "./SubComment.vue";
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import { dragscroll } from "vue-dragscroll";

export default {
  props: ["comment"],
  directives: {
    dragscroll
  },
  components: {
    SubComment
  },
  data() {
    return {
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      subCommentOpen: false,
      newComment: false,
      users: [],
      isCommentMentionVisible: false,
      commentForm: {
        id: null,
        postId: this.comment.postId,
        commentText: null,
        parentId: this.comment.id,
        mentions: []
      },
      moment,
      searchTerm: null,
      loading: false,
      timeout: null,
      loadCommentBtn: true,
      firstOpen: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    openUserModal(post) {
      if(post.owner.id != null){
        this.$root.$emit("getProfile", post.owner.id);

      }
    },
    async deleteComment(id) {
      await this.$store.dispatch("deleteComment", id);
    },
    async loadComment() {
      this.loading = "loadComments";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("/SocialHub/ListComments", {
          skip: this.comment.subComments.length,
          take: 5,
          parentId: this.comment.id,
          postId: this.comment.postId
        });
        var comments = res.data.data.items;
        if (comments.length > 0) {
          this.comment.subComments.push(...comments.reverse());
        } else {
          this.loadCommentBtn = false;
        }
        this.loading = false;
      }, 500);
    },
    commentMention(post) {
      if (this.commentForm.commentText != "" && this.commentForm.commentText != null) {
        this.commentForm.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            setTimeout(() => {
              axios
                .post("socialhub/searchmention", {
                  searchTerm: this.searchTerm
                })
                .then(res => {
                  this.users = res.data.data.items;
                });
            }, 1000);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    postComment() {
      this.loading = "postCommentLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.commentForm.commentText;
        this.commentForm.mentions.forEach(user => {
          commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
        });
        var res = await axios.post("socialhub/addupdatecomment", {
          id: null,
          parentId: this.comment.id,
          postId: this.comment.postId,
          commentText: commentTitle != "" ? commentTitle : this.commentForm.commentText,
          mentions: this.commentForm.mentions
        });
        if (res.data.hasError == true) {
          this.$message.error(res.data.message);
        } else {
          // this.comment.subCommentCount += 1;
          this.firstOpen = true;
          this.openSubComment();
          this.commentForm.commentText = null;
          this.users = [];
        }
        this.newComment = false;
        this.loading = false;
      }, 500);
    },
    tagUser(user, post) {
      this.isCommentMentionVisible = false;
      this.commentForm.commentText = this.commentForm.commentText.replaceAll("@" + this.searchTerm, user.fullName);
      this.commentForm.mentions.push(user);
      this.users = [];
      this.searchTerm = "";
    },
    async openSubComment() {
      if (!this.firstOpen) {
        var res = await axios.post("/SocialHub/ListComments", {
          skip: this.comment.subComments.length,
          take: 5,
          parentId: this.comment.id,
          postId: this.comment.postId
        });
        var comments = res.data.data.items;
        if (comments.length > 0) {
          this.comment.subComments.push(...comments.reverse());
        }
        if (res.data.data.items.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.firstOpen = true;
      }
      this.subCommentOpen = !this.subCommentOpen;
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    },
    async toggleLikeComment() {
      this.loading = "commentLike";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.comment.id,
          postId: this.comment.postId,
          isLiked: !this.comment.isLiked
        };
        var res = await this.$store.dispatch("toggleLikeComment", payload);
        if (!res.data.hasError) {
          this.comment.isLiked = !this.comment.isLiked;
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less">
.social-comment {
  max-width: 100%;
  padding: 10px 0px 10px 0;
  margin-right: 0px;
  border-top: 0.5px solid rgba(200, 205, 211, 0.4);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  .comment-header {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      cursor: pointer;
      user-select: none;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #e8ebef;
      object-fit: cover;
    }
    .comment-user-title {
      cursor: pointer;
      user-select: none;
      display: flex;
      flex-direction: column;
      .comment-user-title-text  {
        font-weight: 600;
        font-size: 13px;
        line-height: 13px;
        letter-spacing: 0.2px;
        color: #000000;
      }
      .time {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.2px;
        color: #8c929c;
      }
    }
    .comment-owner {
      margin-left: auto;
    }
  }
  .comment-body {
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #292f3b;
    .comment-text {
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #505763;
      span {
        word-wrap: break-word;
      }
    }
    .comment-buttons {
      .sub-comment-count {
        font-size: 11px;
      }
      display: flex;
      align-items: center;
      gap: 4px;

      font-weight: 400;
      font-size: 11px;
      letter-spacing: 0.2px;
      cursor: pointer;
      color: #292f3b;
      height: 20px;

      & > span {
        cursor: pointer;
        user-select: none;
      }
      .comment-reply {
        font-weight: 700;
        text-decoration-line: underline;
        cursor: pointer;
      }
      .like-area {
        margin-left: auto;
        display: flex;
        align-items: center;
        margin-right: 8px;
        cursor: pointer;
        flex-direction: row;
        & > i {
          font-size: 14px;
          margin-left: 5px;
          &.active {
            transition: all 0.2s;
            color: #ff6565;
          }
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/socialHub/Comment.vue